module.exports = __webpack_public_path__ + "static/media/forward-icon.7239df74.svg";